import React from 'react';
import styled from 'styled-components';
import parse from 'html-react-parser';

import Section from '@sections/SectionWrapper';
import ArrowLink from '../../elements/ArrowLink';
import MainButton from '../../elements/MainButton';

import Link from '@util/link';

import { BaseCallout, BodyText16 } from '@styled-components/Typography';

const HelpCard = styled(Link)`
	background-color: ${({ theme }) => theme.colors.cream.main};
	padding: 4rem;
	border-radius: ${({ theme }) => theme.borderRadius.small}px;
	transition: background-color 0.5s ease;
	display: flex;
	align-items: center;

	:hover {
		cursor: pointer;
		background-color: ${({ theme }) => theme.colors.cream.dark};
		svg {
			transform: translateX(4px);
		}
	}
`;

const CalloutHeader = styled(BaseCallout)`
	font-size: 1.4rem;
	line-height: 100%; /* 14px */
`;

const HelpGrid = styled.div`
	display: grid;
	gap: 4rem;

	${({ theme }) => theme.mediaQuery.breakpointLg} {
		grid-template-columns: ${({ hasNote }) => hasNote && '1fr 2fr'};
		gap: 80px;
	}
`;

const CardGrid = styled.div`
	display: grid;
	gap: 2rem;

	${({ theme }) => theme.mediaQuery.breakpointLg} {
		grid-template-columns: repeat(${({ hasNote }) => (hasNote ? 2 : 3)}, 1fr);
	}
`;

const MainButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 4rem;
`;

const StackedArrowCards = ({
	header,
	subheader,
	note,
	cards,
	cta,
	...props
}) => {
	const hasNote = typeof note === 'object' && note !== null;
	return (
		<Section header={header} subheader={subheader} {...props}>
			<HelpGrid hasNote={hasNote}>
				{note && (
					<div>
						<CalloutHeader>{note.header}</CalloutHeader>
						<BodyText16>{parse(note.description)}</BodyText16>
						<ArrowLink
							linkText={note.arrowLinkText}
							link={note.arrowLinkUrl}
							arrowSize={20}
						/>
					</div>
				)}
				<CardGrid hasNote={hasNote}>
					{cards.map(card => (
						<HelpCard to={card.link}>
							<ArrowLink linkText={card.text} link={card.link} arrowSize={20} />
						</HelpCard>
					))}
				</CardGrid>
			</HelpGrid>
			<MainButtonWrapper>
				{cta?.link && <MainButton linkUrl={cta.link}>{cta.text}</MainButton>}
			</MainButtonWrapper>
		</Section>
	);
};

export default StackedArrowCards;
